/* eslint-disable */


// Programatically generated on Mon Feb 02 2026 23:59:21 GMT+0000
import {fromJS, List, Map, Record, Set} from 'immutable';
import {GenericModel} from 'resources/Generic.model';
import {validate, Empty} from '@albert-io/json-api-framework/models/helpers';
import moment from 'moment';

const ModelConfig = fromJS(
  {
    'endpoint': 'schools_v5',
    'attributes': {
      'postal_code': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'began_beta_testing_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'license_notification_sent_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'school_type': {
        'type': 'string',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'city': {
        'type': 'string',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'name': {
        'type': 'string',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'state': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'address_line_1': {
        'type': 'string',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'address_line_2': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'restrict_classroom_enrollment': {
        'type': 'boolean',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'clever_id': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'country': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'updated_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'allow_translations': {
        'type': 'boolean',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'custom_message': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'inserted_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'id': {
        'type': 'binary_id',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'hard_cap': {
        'type': 'boolean',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      }
    },
    'relationships': {
      'students_v1': {
        'type': 'one-to-many'
      },
      'students_v2': {
        'type': 'one-to-many'
      },
      'school_personnel_v1': {
        'type': 'one-to-many'
      },
      'teachers_v1': {
        'type': 'one-to-many'
      },
      'school_personnel_invitations_v1': {
        'type': 'one-to-many'
      },
      'district_v1': {
        'type': 'one-to-one'
      },
      'email_domains_v1': {
        'type': 'one-to-many'
      },
      'managed_users_v1': {
        'type': 'one-to-many'
      },
      'student_classrooms_v1': {
        'type': 'one-to-many'
      },
      'classrooms_v1': {
        'type': 'one-to-many'
      },
      'school_licenses_v1': {
        'type': 'one-to-many'
      }
    }
  }
);

const ModelRecord = Record(
  {
    'classrooms': Empty,
    'postal_code': Empty,
    'began_beta_testing_at': Empty,
    'license_notification_sent_at': Empty,
    'student_classrooms': Empty,
    'school_type': Empty,
    'managed_users': Empty,
    'city': Empty,
    'name': Empty,
    'email_domains': Empty,
    'district': Empty,
    'school_personnel_invitations': Empty,
    'state': Empty,
    'teachers': Empty,
    'address_line_1': Empty,
    'address_line_2': Empty,
    'restrict_classroom_enrollment': Empty,
    'clever_id': Empty,
    'school_personnel': Empty,
    'country': Empty,
    'updated_at': Empty,
    'allow_translations': Empty,
    'students': Empty,
    'custom_message': Empty,
    'inserted_at': Empty,
    'id': Empty,
    'relationshipMeta': Empty,
    'school_licenses': Empty,
    'hard_cap': Empty,
    'meta': new Map({
    'count_of_available_seats': Empty,
    'license_expiration_date': Empty,
    'count_of_approved_teachers': Empty,
    'populated_metadata_fields': Empty,
    'count_of_emailable_admins': Empty,
    'license_start_date': Empty,
    'count_of_teachers': Empty,
    'count_of_students': Empty,
    'count_of_pending_teachers': Empty,
    'count_of_approved_admins': Empty,
    'total_time_elapsed_intervals': Empty,
    'license_type': Empty,
    'count_of_classrooms': Empty,
    'is_license_active': Empty,
    'count_of_guesses_intervals': Empty,
    'count_of_subjects': Empty
  })
  }
);

const DefaultModel = fromJS(
  {
    'postal_code': '',
    'school_type': '',
    'city': '',
    'name': '',
    'state': '',
    'address_line_1': '',
    'address_line_2': '',
    'clever_id': '',
    'country': '',
    'custom_message': '',
    'id': '',
    'began_beta_testing_at': new Date(),
    'license_notification_sent_at': new Date(),
    'updated_at': new Date(),
    'inserted_at': new Date(),
    'classrooms': new List(),
    'student_classrooms': new List(),
    'managed_users': new List(),
    'email_domains': new List(),
    'school_personnel_invitations': new List(),
    'teachers': new List(),
    'school_personnel': new List(),
    'students': new List(),
    'meta': new Map(),
    'district': new Map(),
    'restrict_classroom_enrollment': false,
    'allow_translations': false,
    'school_licenses': new List(),
    'relationshipMeta': new Map(),
    'hard_cap': true
  }
);

export class SchoolModelV5 extends GenericModel(ModelRecord, ModelConfig, 'SchoolModelV5') {
  // -- Query Rules --
  /**
   * @returns {boolean}
   */
  static allowsInclude(include) {
    // AllowedIncludes is currently disabled.
    return true; // AllowedIncludes.has(include);
  }

  /**
   * @returns {boolean}
   */
  static allowsFilter(filterField, filterType) {
    return filterType ?
      FilterRules.get(filterField).has(filterType) :
      FilterRules.has(filterField);
  }

  /**
   * @returns {boolean}
   */
  static allowsSort(sort) {
    return sort.split(',').filter((s) => AllowedSorts.has(s)).length > 0;
  }

  /**
   * @returns {Array}
   */
  static getAllowedSorts() {
    return AllowedSorts.keySeq().toJS();
  }

  static getMetaContextQuery(key) {
    if (!MetadataContextRules.hasIn(['optional', key]) && !MetadataContextRules.hasIn(['required', key])) {
      console.error('Rule for meta context key ' + key + ' does not exist');
    }

    return MetadataContextRules.getIn(['optional', key]) || MetadataContextRules.getIn(['required', key]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getRequiredMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values()]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getAllMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values(), ...MetadataContextRules.get('optional').values()]);
  }

  static getDefaultModel() {
    _emptySchoolModelV5Model = _emptySchoolModelV5Model ? _emptySchoolModelV5Model : new SchoolModelV5(DefaultModel);
    return _emptySchoolModelV5Model;
  }

  static supportsMetaContext() {
    return MetadataContextRules !== null;
  }

  /**
   * @returns {string}
   */
  static getModelName() {
    return 'SchoolModelV5';
  }

  /**
   * @returns {boolean}
   */
  static _isFullSpec() {
    return true;
  }

  constructor() {
    super(...arguments);
    this.__meta = null;
  }

  /**
   * @returns {string}
   */
  getJsonApiType() {
    return 'school_v5';
  }

  /**
   * @params {string} - An attribute name
   * @params {*} [def] - Optional default value override for the attribute
   */
  getValueForAttribute(attribute, def) {
    let value = this.get(attribute);
    validate(value, attribute);
    if (value === Empty) {
      value = def !== undefined ? def : DefaultModel.get(attribute);
    }
    return value;
  }

  // -- Primary Attributes --
  
  /**
   * @type {string}
   */
  getAddressLine1() {
    const value = this.getValueForAttribute('address_line_1');
    return value;
  }

  setAddressLine1(value) {
    return this.setField('address_line_1', value);
  }

  /**
   * @type {string}
   */
  getAddressLine2() {
    const value = this.getValueForAttribute('address_line_2');
    return value;
  }

  setAddressLine2(value) {
    return this.setField('address_line_2', value);
  }

  /**
   * @type {boolean}
   */
  isAllowTranslations() {
    const value = this.getValueForAttribute('allow_translations');
    return value;
  }

  setAllowTranslations(value) {
    return this.setField('allow_translations', value);
  }

  /**
   * @type {datetime}
   */
  getBeganBetaTestingAt() {
    const value = this.getValueForAttribute('began_beta_testing_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  setBeganBetaTestingAt(value) {
    const momentValue = moment(value);
    return this.setField('began_beta_testing_at', momentValue.isValid() ? momentValue : value);
  }

  /**
   * @type {string}
   */
  getCity() {
    const value = this.getValueForAttribute('city');
    return value;
  }

  setCity(value) {
    return this.setField('city', value);
  }

  /**
   * @type {string}
   */
  getCleverId() {
    const value = this.getValueForAttribute('clever_id');
    return value;
  }

  setCleverId(value) {
    return this.setField('clever_id', value);
  }

  /**
   * @type {string}
   */
  getCountry() {
    const value = this.getValueForAttribute('country');
    return value;
  }

  setCountry(value) {
    return this.setField('country', value);
  }

  /**
   * @type {string}
   */
  getCustomMessage() {
    const value = this.getValueForAttribute('custom_message');
    return value;
  }

  setCustomMessage(value) {
    return this.setField('custom_message', value);
  }

  /**
   * @type {boolean}
   */
  isHardCap() {
    const value = this.getValueForAttribute('hard_cap');
    return value;
  }

  setHardCap(value) {
    return this.setField('hard_cap', value);
  }

  /**
   * @type {binary_id}
   */
  getId() {
    const value = this.getValueForAttribute('id');
    return value;
  }

  setId(value) {
    return this.setField('id', value);
  }

  /**
   * @type {datetime}
   */
  getInsertedAt() {
    const value = this.getValueForAttribute('inserted_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {datetime}
   */
  getLicenseNotificationSentAt() {
    const value = this.getValueForAttribute('license_notification_sent_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  setLicenseNotificationSentAt(value) {
    const momentValue = moment(value);
    return this.setField('license_notification_sent_at', momentValue.isValid() ? momentValue : value);
  }

  /**
   * @type {string}
   */
  getName() {
    const value = this.getValueForAttribute('name');
    return value;
  }

  setName(value) {
    return this.setField('name', value);
  }

  /**
   * @type {string}
   */
  getPostalCode() {
    const value = this.getValueForAttribute('postal_code');
    return value;
  }

  setPostalCode(value) {
    return this.setField('postal_code', value);
  }

  /**
   * @type {boolean}
   */
  isRestrictClassroomEnrollment() {
    const value = this.getValueForAttribute('restrict_classroom_enrollment');
    return value;
  }

  setRestrictClassroomEnrollment(value) {
    return this.setField('restrict_classroom_enrollment', value);
  }

  /**
   * @type {string}
   */
  getSchoolType() {
    const value = this.getValueForAttribute('school_type');
    return value;
  }

  setSchoolType(value) {
    return this.setField('school_type', value);
  }

  /**
   * @type {string}
   */
  getState() {
    const value = this.getValueForAttribute('state');
    return value;
  }

  setState(value) {
    return this.setField('state', value);
  }

  /**
   * @type {datetime}
   */
  getUpdatedAt() {
    const value = this.getValueForAttribute('updated_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  // -- Meta Attributes --
  
    /**
     * LEGACY META ACCESSORS
     * @todo These should no longer be used, instead use this.getMeta()[...]
     */
    
      getCountOfApprovedAdmins() {
        return this.getMeta().getCountOfApprovedAdmins();
      }
    
      getCountOfApprovedTeachers() {
        return this.getMeta().getCountOfApprovedTeachers();
      }
    
      getCountOfAvailableSeats() {
        return this.getMeta().getCountOfAvailableSeats();
      }
    
      getCountOfClassrooms() {
        return this.getMeta().getCountOfClassrooms();
      }
    
      getCountOfEmailableAdmins() {
        return this.getMeta().getCountOfEmailableAdmins();
      }
    
      getCountOfGuessesIntervals() {
        return this.getMeta().getCountOfGuessesIntervals();
      }
    
      getCountOfPendingTeachers() {
        return this.getMeta().getCountOfPendingTeachers();
      }
    
      getCountOfStudents() {
        return this.getMeta().getCountOfStudents();
      }
    
      getCountOfSubjects() {
        return this.getMeta().getCountOfSubjects();
      }
    
      getCountOfTeachers() {
        return this.getMeta().getCountOfTeachers();
      }
    
      isLicenseActive() {
        return this.getMeta().isLicenseActive();
      }
    
      getLicenseExpirationDate() {
        return this.getMeta().getLicenseExpirationDate();
      }
    
      getLicenseStartDate() {
        return this.getMeta().getLicenseStartDate();
      }
    
      getLicenseType() {
        return this.getMeta().getLicenseType();
      }
    
      getPopulatedMetadataFields() {
        return this.getMeta().getPopulatedMetadataFields();
      }
    
      getTotalTimeElapsedIntervals() {
        return this.getMeta().getTotalTimeElapsedIntervals();
      }
    
    getMeta() {
      if (this.__meta) {
        return this.__meta;
      }
      const meta = this.get('meta', Map());
      this.__meta = {
        
          /**
           * @type {integer}
           */
          getCountOfApprovedAdmins() {
            const value = meta.get('count_of_approved_admins');
            validate(value, 'count_of_approved_admins');
            
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
          },
  
          /**
           * @type {integer}
           */
          getCountOfApprovedTeachers() {
            const value = meta.get('count_of_approved_teachers');
            validate(value, 'count_of_approved_teachers');
            
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
          },
  
          /**
           * @type {integer}
           */
          getCountOfAvailableSeats() {
            const value = meta.get('count_of_available_seats');
            validate(value, 'count_of_available_seats');
            
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
          },
  
          /**
           * @type {integer}
           */
          getCountOfClassrooms() {
            const value = meta.get('count_of_classrooms');
            validate(value, 'count_of_classrooms');
            
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
          },
  
          /**
           * @type {integer}
           */
          getCountOfEmailableAdmins() {
            const value = meta.get('count_of_emailable_admins');
            validate(value, 'count_of_emailable_admins');
            
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
          },
  
          /**
           * @type {map[]}
           */
          getCountOfGuessesIntervals() {
            const value = meta.get('count_of_guesses_intervals');
            validate(value, 'count_of_guesses_intervals');
            return value;
          },
  
          /**
           * @type {integer}
           */
          getCountOfPendingTeachers() {
            const value = meta.get('count_of_pending_teachers');
            validate(value, 'count_of_pending_teachers');
            
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
          },
  
          /**
           * @type {integer}
           */
          getCountOfStudents() {
            const value = meta.get('count_of_students');
            validate(value, 'count_of_students');
            
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
          },
  
          /**
           * @type {integer}
           */
          getCountOfSubjects() {
            const value = meta.get('count_of_subjects');
            validate(value, 'count_of_subjects');
            
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
          },
  
          /**
           * @type {integer}
           */
          getCountOfTeachers() {
            const value = meta.get('count_of_teachers');
            validate(value, 'count_of_teachers');
            
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
          },
  
          /**
           * @type {boolean}
           */
          isLicenseActive() {
            const value = meta.get('is_license_active');
            validate(value, 'is_license_active');
            return value;
          },
  
          /**
           * @type {datetime}
           */
          getLicenseExpirationDate() {
            const value = meta.get('license_expiration_date');
            validate(value, 'license_expiration_date');
            
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
          },
  
          /**
           * @type {datetime}
           */
          getLicenseStartDate() {
            const value = meta.get('license_start_date');
            validate(value, 'license_start_date');
            
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
          },
  
          /**
           * @type {string}
           */
          getLicenseType() {
            const value = meta.get('license_type');
            validate(value, 'license_type');
            return value;
          },
  
          /**
           * @type {string[]}
           */
          getPopulatedMetadataFields() {
            const value = meta.get('populated_metadata_fields');
            validate(value, 'populated_metadata_fields');
            return value;
          },
  
          /**
           * @type {map[]}
           */
          getTotalTimeElapsedIntervals() {
            const value = meta.get('total_time_elapsed_intervals');
            validate(value, 'total_time_elapsed_intervals');
            return value;
          },
  
      };
      return this.__meta;
    }
  
  // -- Relationships --
  
  /**
   * @type {classroom_v1 (many)}
   */
  getClassrooms() {
    const value = this.getValueForAttribute('classrooms');
    return value;
  }

  // -- Relationship Fields: classrooms --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {student_classroom_v1 (many)}
   */
  getStudentClassrooms() {
    const value = this.getValueForAttribute('student_classrooms');
    return value;
  }

  // -- Relationship Fields: student_classrooms --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {managed_user_v1 (many)}
   */
  getManagedUsers() {
    const value = this.getValueForAttribute('managed_users');
    return value;
  }

  // -- Relationship Fields: managed_users --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {email_domain_v1 (many)}
   */
  getEmailDomains() {
    const value = this.getValueForAttribute('email_domains');
    return value;
  }

  // -- Relationship Fields: email_domains --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {district_v1 (one)}
   */
  getDistrict() {
    const value = this.getValueForAttribute('district');
    return value;
  }

  // -- Relationship Fields: district --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {school_personnel_invitation_v1 (many)}
   */
  getSchoolPersonnelInvitations() {
    const value = this.getValueForAttribute('school_personnel_invitations');
    return value;
  }

  // -- Relationship Fields: school_personnel_invitations --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {teacher_v1 (many)}
   */
  getTeachers() {
    const value = this.getValueForAttribute('teachers');
    return value;
  }

  // -- Relationship Fields: teachers --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {school_personnel_v1 (many)}
   */
  getSchoolPersonnel() {
    const value = this.getValueForAttribute('school_personnel');
    return value;
  }

  // -- Relationship Fields: school_personnel --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {student_v2 (many)}
   */
  getStudents() {
    const value = this.getValueForAttribute('students');
    return value;
  }

  // -- Relationship Fields: students --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {school_license_v1 (many)}
   */
  getSchoolLicenses() {
    const value = this.getValueForAttribute('school_licenses');
    return value;
  }

  // -- Relationship Fields: school_licenses --
  // no 'fields' found, skipped generating accessor(s)
  
}

// -- Empty Model Instance --
let _emptySchoolModelV5Model = null;

// -- Sort Rules --

const AllowedSorts = fromJS({
  'address_line_1': null,
  'address_line_2': null,
  'allow_translations': null,
  'began_beta_testing_at': null,
  'city': null,
  'clever_id': null,
  'country': null,
  'custom_message': null,
  'hard_cap': null,
  'id': null,
  'inserted_at': null,
  'license_notification_sent_at': null,
  'meta.count_of_approved_admins': null,
  'meta.count_of_approved_teachers': null,
  'meta.count_of_available_seats': null,
  'meta.count_of_classrooms': null,
  'meta.count_of_emailable_admins': null,
  'meta.count_of_pending_teachers': null,
  'meta.count_of_students': null,
  'meta.count_of_subjects': null,
  'meta.count_of_teachers': null,
  'meta.is_license_active': null,
  'meta.license_expiration_date': null,
  'meta.license_start_date': null,
  'meta.license_type': null,
  'name': null,
  'postal_code': null,
  'restrict_classroom_enrollment': null,
  'school_type': null,
  'state': null,
  'updated_at': null,
});

// -- Include Rules --
// List []

// -- Filter Rules --
const FilterRules = new Map({
  'address_line_1': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'address_line_2': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'allow_translations': new Set(['exact','not','null']),
  'began_beta_testing_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'city': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'classrooms_v1': new Set(['associated']),
  'clever_id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'country': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix']),
  'custom_message': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'district_v1': new Set(['associated']),
  'email_domains_v1': new Set(['associated']),
  'hard_cap': new Set(['exact','not','null']),
  'id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'inserted_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'license_notification_sent_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'managed_users_v1': new Set(['associated']),
  'meta.count_of_approved_admins': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.count_of_approved_teachers': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.count_of_available_seats': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.count_of_classrooms': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.count_of_emailable_admins': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.count_of_pending_teachers': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.count_of_students': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.count_of_subjects': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.count_of_teachers': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.is_license_active': new Set(['exact','not','null']),
  'meta.license_expiration_date': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.license_start_date': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.license_type': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'meta.populated_metadata_fields': new Set(['null']),
  'name': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'postal_code': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'restrict_classroom_enrollment': new Set(['exact','not','null']),
  'school_licenses_v1': new Set(['associated']),
  'school_personnel_invitations_v1': new Set(['associated']),
  'school_personnel_v1': new Set(['associated']),
  'school_type': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix']),
  'state': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'student_classrooms_v1': new Set(['associated']),
  'students_v1': new Set(['associated']),
  'students_v2': new Set(['associated']),
  'teachers_v1': new Set(['associated']),
  'updated_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
});
    

// -- Metadata Context Rules --
const MetadataContextRules = fromJS({
  optional: {
    'end_date': 'meta.context.end_date',
    'include_emailable_admins': 'meta.context.include_emailable_admins',
    'school_id': 'meta.context.school.id',
    'school_personnel_statuses': 'meta.context.school_personnel.statuses',
    'start_date': 'meta.context.start_date',
    'time_series_step': 'meta.context.time_series_step',
  },
  required: {
  }
});

// -- Legacy Name Export --
export const School = SchoolModelV5;
